export default "__VITE_ASSET__7a8103ad__"